/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function RainbowCloud(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M248,160a48.054,48.054,0,0,1-48,48H152c-17.645,0-32-14.75391-32-32.88867s14.355-32.88867,32-32.88867a31.5421,31.5421,0,0,1,3.33545.17578A48.00491,48.00491,0,0,1,248,160ZM112,72a87.53238,87.53238,0,0,1,61.34814,24.91016,8.00027,8.00027,0,0,0,11.15528-11.47071A104.00011,104.00011,0,0,0,8,160v16a8,8,0,0,0,16,0V160A88.09957,88.09957,0,0,1,112,72Zm0,32a55.55123,55.55123,0,0,1,33.12842,10.84473A7.99959,7.99959,0,1,0,154.605,101.9541,72.00452,72.00452,0,0,0,40,160v16a8,8,0,0,0,16,0V160A56.06322,56.06322,0,0,1,112,104Zm15.20508,26.71289a7.99944,7.99944,0,0,0-5.936-9.63086A40.02529,40.02529,0,0,0,72,160v16a8,8,0,0,0,16,0V160a24.02909,24.02909,0,0,1,29.57373-23.35156A7.99553,7.99553,0,0,0,127.20508,130.71289Z" />
    </Svg>
  );
}

export default RainbowCloud;
